module.exports = __webpack_public_path__ + "img/envira-brands.ba26f209.svg";